<template>
  <div v-show="bodyShow" class="main">
    <div v-for="(item,index) in list" :key="index" class="list">
      <div class="list-content">
        <img :src="item.promotionimg" />
        <div class="content-right">
          <h2 :class="['text-ellipsis',item.end?'color9':'']" :title="item.name">{{item.bname}}</h2>
          <div class="tag-group">
            <h3 :class="['h3',item.end?'color9 bgf0':'']">{{item.name}}</h3>
            <h3 v-if="item.describe" :class="['h3',item.end?'color9 bgf0':'']">{{item.describe}}</h3>
          </div>
          <!-- <p :class="[item.end?'color9':'']" :title="item.describe">{{item.describe}}</p> -->
          <h3 :class="['person',item.end?'color9':'']" >小组学员{{item.groupnum}}人<span style="margin-left:auto;"></span>项目进度：{{item.project}}</h3>
        </div>
      </div>
      <!--  -->
      <div class="list-footer">
        <router-link v-if="item.groupnum>0" :class="{'on':item.groupnum>0}" :to="{
            path:'/ta_student_information',
            query:{
                cid:item.cid
            }
          }"
        >学员资料</router-link>
        <a v-else>学员资料</a>
        <router-link v-show="!isMain" :class="{'on':!item.describe}" :to="{
            path:'/ta_basic_data',
            query:{
                course_id:item.cid
            }
          }"
        >查看数据</router-link>
        <!-- 先同意改为一个页面，保留之前的列表页 -->
        <router-link v-show="!isMain" class="on" :to="{
            path:'/list',
            query:{
                cid:item.cid
            }
          }"
        >进入课程</router-link>
         <router-link v-show="isMain" class="on" :to="{
            path:'/ta_project_list',
            query:{
                cid:item.cid
            }
          }"
        >进入课程</router-link>
      </div>
      <img v-if="item.end" class="right-end-course" src="@a/end_course.png" alt />
    </div>
    <div v-if="isShow" class="list-no">
      <img src="@a/ta_period.png" alt />
      <p>课程报名还未截止，暂未为您分配学员</p>
    </div>
  </div>
</template>
<script>
import { isMain } from '@/utils/tools'
import { TutorList, inviteDo } from "@/api/assistant";
import { shareCon } from "@/utils/wxconfig";
export default {
  data() {
    return {
      bodyShow: false,
      list: [],
      isShow: false,
      isMain: isMain()
    }
  },
  methods: {
    // 初始化获取数据
    pullData() {
      TutorList().then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          this.isShow = true;
          return;
        }
        this.list = data.list;
        this.bodyShow = true;
      });
    }
  },
  created() {
    this.pullData();
    shareCon("course", this);
  }
};
</script>
<style lang="scss" scoped>
.bgf0{
  background-color: #F0F0F0 !important;
}
.color9{
  color: #999999 !important;
}
.main {
  padding: 30px;
  position: relative;
  .list {
    padding: 30px 20px 20px 20px;
    background-color: #ffffff;
    margin-bottom: 16px;
    position: relative;
    .list-content {
      margin-bottom: 30px;
      img {
        width: 200px;
        height: 126px;
        margin-right: 20px;
        object-fit: contain;
        display: inline-block;
        vertical-align: top;
      }
      .content-right {
        display: inline-block;
        width: 415px;
        h2 {
          font-size: 26px;
          color: #333333;
          line-height: 1;
        }
        .tag-group{
          display: flex;
          h3.h3{
            font-size: 22px;
            color: #EB5032;
            background:rgba(235,80,50,.1);
            padding: 6px 10px;
            width: max-content;
            margin: 10px 0 32px;
            &:nth-child(2){
              margin-left: 10px;
            }
          }
        }
        p {
          line-height: 1;
          font-size: 24px;
          color: #999999;
        }
        h3.person {
          display: flex;
          font-size: 22px;
          color: #EB5032;
        }
      }
    }
    .list-footer {
      font-size: 0;
      text-align: right;
      a {
        display: inline-block;
        font-size: 24px;
        color: #999999;
        border: 2px solid #cccccc;
        padding: 0 20px;
        line-height: 48px;
        border-radius: 24px;
        margin-left: 10px;
      }
      a.on {
        color: #eb5032;
        border: 2px solid #eb5032;
      }
    }
    .right-end-course {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 8;
      width: 88px;
      height: 88px;
    }
  }
  .list-no {
    position: fixed;
    text-align: center;
    width: 100%;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    img {
      width: 180px;
      height: 132px;
    }
    p {
      font-size: 26px;
      margin-top: 30px;
      color: #999999;
    }
  }
}
</style>
